export function normalizeNavPath(p: string): string {
  if (!p || p === '/') return '/';
  const t = p.replace(/\/$/, '');
  return t === '' ? '/' : t;
}

/** Matches current URL to a nav item path (supports nested routes, e.g. /academics/:tab). */
export function isNavItemActive(pathname: string, itemFullPath: string): boolean {
  const nPath = normalizeNavPath(pathname);
  const nItem = normalizeNavPath(itemFullPath);
  return nPath === nItem || nPath.startsWith(`${nItem}/`);
}

/** Exact path only — use below lg for parent rows so child rows are the sole highlight. */
export function isNavItemExactActive(pathname: string, itemFullPath: string): boolean {
  return normalizeNavPath(pathname) === normalizeNavPath(itemFullPath);
}
